import { render, staticRenderFns } from "./CustomerForm.vue?vue&type=template&id=b5d85a68&scoped=true"
import script from "./CustomerForm.vue?vue&type=script&lang=js"
export * from "./CustomerForm.vue?vue&type=script&lang=js"
import style0 from "./CustomerForm.vue?vue&type=style&index=0&id=b5d85a68&prod&lang=stylus"
import style1 from "./CustomerForm.vue?vue&type=style&index=1&id=b5d85a68&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5d85a68",
  null
  
)

export default component.exports